import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

import { getPlaceholderNodes } from '@components/text-editors/addons/field-mapping';

const EXTENSION_NAME = 'singleField';

export const SingleField = Extension.create({
  name: EXTENSION_NAME,
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey(EXTENSION_NAME),

        filterTransaction: (transaction, state) => {
          const placeholderNodes = getPlaceholderNodes(state);
          const newPlaceholderNodes = getPlaceholderNodes(transaction);
          const newNode = newPlaceholderNodes.find(
            (node) => placeholderNodes.findIndex((n) => n === node) === -1,
          );

          if (newNode) {
            transaction.deleteRange(0, transaction.doc.content.size - 1);
            transaction.insert(1, newNode);
          }

          return true;
        },
      }),
    ];
  },
});
